// this is aliased in webpack config based on server/client build

/* globals localStorage */

import axios from 'axios'
import moment from 'moment'
import md5 from 'md5'
// import { Message } from 'element-ui'
import swal from 'sweetalert2'
import { URL, API } from './common'
import router from '@/router'
import { expire } from './auth'
axios.defaults.withCredentials = true

axios.defaults.baseURL = URL + API
axios.defaults.headers.common['Gddx-Access-AppId'] = 'web'
axios.defaults.headers.post['Content-Type'] = 'application/json'
axios.defaults.headers.delete['Content-Type'] = 'application/json'

function signFormat (props) {
  return md5(Object.keys(props).map(el => (el + '=' + props[el]).toLowerCase()).sort().join('&') + sessionStorage.token)
}

export function httpHeader (props, timeStamp) {
  let sign = {
    'Gddx-Access-Token': sessionStorage.token,
    'Gddx-Access-Version': '0.1.0'
  }
  return {
    ...props.headers,
    'Gddx-Access-Sign': signFormat({
      ...sign,
      ...props.params,
      ...props.data,
      'Gddx-Access-TimeStamp': timeStamp
    }),
    'Gddx-Access-TimeStamp': timeStamp,
    'Gddx-Access-Token': sign['Gddx-Access-Token'],
    'Gddx-Access-Version': sign['Gddx-Access-Version']
  }
}

export function fetch (props) {
  console.log(props)
  if (!expire() & props.url !== 'login') {
    // 长时间未操作，跳转到登录页
    throw Object({
      response: {
        status: 401,
        statusText: ''
      }
    })
  }
  const timeStamp = moment().format('x')
  return axios({
    ...props,
    headers: httpHeader(props, timeStamp),
    params: {
      ...props.params,
      timeStamp: timeStamp
    }
  }).then(function (response) {
    if (response) {
      if (response.data.code * 1 === 0) {
        return response.data.data || response.data
      } else {
        throw Object({
          response: {
            status: response.data.code,
            statusText: response.data.message
          }
        })
      }
    }
  }).catch((error) => {
    if (error.response.status === 401 || error.response.status === 403) {
      router.push('/login')
    } else {
      // Message({
      //   type: 'error',
      //   showClose: true,
      //   message: error.response.status + ':' + error.response.statusText
      // })
      swal('操作失败', `${error.response.statusText}`, 'error')
    }
    return false
  })
}

export function fetchList (props) {
  return fetch({
    method: 'get',
    url: props.resource,
    params: {
      orderBy: props.orderBy,
      filterBy: props.filterBy,
      pageSize: props.pageSize,
      pageIndex: props.pageIndex,
      ...props.data
    }
  })
}

export function fetchItem (props) {
  return fetch({
    method: 'get',
    url: props.resource + '/' + props.id
  })
}

export function fetchCreate (props) {
  return fetch({
    method: 'post',
    url: props.resource,
    data: props.data
  })
}

export function fetchUpdate (props) {
  return fetch({
    method: 'put',
    url: props.resource + '/' + props.id,
    data: props.data
  })
}

export function fetchDelete (props) {
  return fetch({
    method: 'delete',
    url: props.resource + '/' + props.id,
    data: {
      ...props.data
    }
  })
}

export function fetchTest (test) {
  return console.log(test)
}

export function fetchRelation (porps) {
  return fetch({
    url: '/relation',
    params: { relationList: porps.params }
  })
}

export function fetchBatch (porps) {
  return fetch({
    method: 'PUT',
    url: porps.url,
    data: { ids: porps.ids }
  })
}



// WEBPACK FOOTER //
// ./src/utils/api.js